import { SENSOR_IMAGES, SENSOR_CONFIG, SENSOR_GROUPS } from './sensorConfig';

export const friendlyNameConverter = (sensorKey) => {
  const sensorSplit = sensorKey.split(':');
  if (sensorSplit.length !== 2) return getSensorType(sensorSplit.at(-1));
  const sensorType = sensorSplit[1].toLowerCase();
  const sensorName = sensorSplit[0] === 'null' ? '' : sensorSplit[0];
  return `${sensorName} ${getSensorType(sensorType)}`;
};

export const getSensorType = (sensorType) => {
  switch (sensorType.toLowerCase()) {
    
    case 'random':
      return `RNG`;
    case 'tvoc_data':
    case 'tvoc(ppm)':
    case 'voc':
    case 'voc_data':
      return `VOC`;
    case 'co2_data':
    case 'co2(ppm)':
    case 'co2':
      return `CO2`;
    case 'temperature_data':
    case 'temp':
      return `Temperature (C)`;
    case 'temperature_data_f':
    case 'temp_f':
      return `Temperature (F)`;
    case 'humidity_data':
    case 'hum':
      return `Humidity (%)`;
    case 'pressure_data':
      return `Pressure (Pa)`;
    case '0.3_per_100_cm^3_data':
    case 'num_particles_0.3':
    case 'sp pm0.3':
      return `0.3um Particles`;
    case '0.5_per_100_cm^3_data':
    case 'num_particles_0.5':
    case 'sp pm0.5':
    case '0.5um particles':
      return `0.5um Particles`;
    case '1.0_per_100_cm^3_data':
    case 'num_particles_1.0':
    case '1.0um particles':
      return `1um Particles`;
    case '2.5_per_100_cm^3_data':
    case 'num_particles_2.5':
    case '2.5um particles':
      return `2.5um Particles`;
    case '5.0_per_100_cm^3_data':
    case 'num_particles_5.0':
    case '5.0um particles':
      return `5um Particles`;
    case '10.0_per_100_cm^3_data':
    case 'num_particles_10.0':
    case '10.0um particles':
      return `10um Particles`;
    case 'pm1.0_ultra_fine_particulates_data':
    case 'pm1.0(ae ppm)':
    case 'ae pm1.0':
    case 'pm1':
      return `PM1.0 Particulates`;
    case 'pm2.5_fine_particles_data':
    case 'pm2.5(ae ppm)':
    case 'ae pm2.5':
    case 'pm2.5':
      return `PM2.5 Particulates`;
    case 'pm10.0_data':
    case 'pm10.0(ae ppm)':
    case 'ae pm10.0':
    case 'ae pm10':
    case 'pm10':
      return `PM10.0 Particulates`;
    case 'hcho(mg/m3)':
      return `Formaldehyde (Mg/m3)`;
    case 'device battery':
      return `Device Battery`;
    case 'device sensor id':
      return `Device Sensor ID`;
    case 'particle count':
      return `Particle Count`;
    case 'hcho_data':
      return `Formaldehyde`;
    default:
      return sensorType;
  }
};

export const getSensorTypeImage = (sensorType) => {
  switch (sensorType.toLowerCase()) {
    case 'formaldehyde':
      return SENSOR_IMAGES.FORMALDEHYDE;
    case 'particle count':
      return SENSOR_IMAGES.PARTICLE_COUNT;
    case 'voc':
      return SENSOR_IMAGES.VOC;
    case 'co2':
      return SENSOR_IMAGES.CO2;
    case 'temperature':
      return SENSOR_IMAGES.TEMPERATURE;
    case 'humidity':
      return SENSOR_IMAGES.HUMIDITY;
    case 'pressure':
      return SENSOR_IMAGES.PRESSURE;
    case '0.3um particles':
      return SENSOR_IMAGES.PARTICLES;
    case '0.5um particles':
      return SENSOR_IMAGES.PARTICLES;
    case '1um particles':
    case '2.5um particles':
    case '5um particles':
    case '10um particles':
    case 'pm1.0':
    case 'pm2.5':
    case 'pm10':
    case 'random':
    default:
      return SENSOR_IMAGES.DEFAULT;
  }
};

export const getSensorObject = (sensorType) => {
  // Input validation
  if (!sensorType || typeof sensorType !== 'string') {
    throw new Error('sensorType must be a non-empty string');
  }
  
  const sensorTypeLower = sensorType.toLowerCase();
  
  // Look up sensor configuration
  const config = SENSOR_CONFIG[sensorTypeLower];
  
  if (!config) {
    // Default case for unknown sensor types
    return {
      matchingIds: [sensorType],
      name: sensorType,
      imageLocation: SENSOR_IMAGES.DEFAULT
    };
  }
  
  // Find the group that contains this sensor type
  const matchingIds = SENSOR_GROUPS[config.name] || [sensorType];
  
  return {
    matchingIds,
    name: config.name,
    imageLocation: config.image
  };
};

// Helper function to get all available sensor types
export const getAllSensorTypes = () => {
  return Object.keys(SENSOR_CONFIG);
};

// Helper function to get all sensor groups
export const getAllSensorGroups = () => {
  return Object.keys(SENSOR_GROUPS);
};

// Helper function to check if a sensor type is valid
export const isValidSensorType = (sensorType) => {
  if (!sensorType || typeof sensorType !== 'string') {
    return false;
  }
  return sensorType.toLowerCase() in SENSOR_CONFIG;
};
